import { render, staticRenderFns } from "./Catalog-Results.vue?vue&type=template&id=019461a1&scoped=true&lang=pug"
import script from "./Catalog-Results.vue?vue&type=script&setup=true&lang=ts"
export * from "./Catalog-Results.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Catalog-Results.vue?vue&type=style&index=0&id=019461a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019461a1",
  null
  
)

export default component.exports